export function monthBounds(year: number, monthIndex: number) {
  const dateFrom = `${year}-${String(monthIndex + 1).padStart(2, '0')}-01`;
  const lastDay = new Date(year, monthIndex + 1, 0).getDate();
  const dateTo = `${year}-${String(monthIndex + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
  return { dateFrom, dateTo };
}

export function formatMonthTitle(year: number, monthIndex: number) {
  const raw = new Date(year, monthIndex, 1).toLocaleDateString('it-IT', {
    month: 'long',
    year: 'numeric',
  });
  return raw.charAt(0).toUpperCase() + raw.slice(1);
}

/** Data locale `YYYY-MM-DD` (non usare `toISOString`: è in UTC e può essere il giorno sbagliato). */
export function localDateYmd(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Ora locale `HH:mm` per input type="time". */
export function localTimeHm(d: Date = new Date()): string {
  const h = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${h}:${min}`;
}

/** Valore `YYYY-MM` per input type="month". */
export function ymToMonthInput(year: number, monthIndex: number): string {
  return `${year}-${String(monthIndex + 1).padStart(2, '0')}`;
}

export function parseMonthInput(value: string): { year: number; monthIndex: number } | null {
  if (!/^\d{4}-\d{2}$/.test(value)) return null;
  const [ys, ms] = value.split('-');
  const year = Number(ys);
  const monthIndex = Number(ms) - 1;
  if (!Number.isFinite(year) || !Number.isFinite(monthIndex) || monthIndex < 0 || monthIndex > 11) {
    return null;
  }
  return { year, monthIndex };
}

export function rangeBoundsFromMonthInputs(startMonth: string, endMonth: string) {
  const start = parseMonthInput(startMonth);
  const end = parseMonthInput(endMonth);
  if (!start || !end) return null;
  const startKey = start.year * 12 + start.monthIndex;
  const endKey = end.year * 12 + end.monthIndex;
  if (endKey < startKey) return null;
  const { dateFrom } = monthBounds(start.year, start.monthIndex);
  const { dateTo } = monthBounds(end.year, end.monthIndex);
  return { dateFrom, dateTo };
}

export function defaultAnalysisPeriod(): { startMonth: string; endMonth: string } {
  const n = new Date();
  return {
    startMonth: ymToMonthInput(n.getFullYear(), 0),
    endMonth: ymToMonthInput(n.getFullYear(), n.getMonth()),
  };
}
